import React, {useEffect, useState, useContext, useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import styles from './LeftPanel.module.css';
import {SwapMainAppContext} from '../../SwapMainAppContext';
import axios from 'axios';
import DeleteChatModal from '../../components/DeleteChatModal';
import PropTypes from 'prop-types';
import PortalDropdown from '../../components/PortalDropdown';
import {useIsMobile} from '../utils'

import logoImg from "../static_files/kiraAi logo.svg";
import transImg from '../static_files/My Assets.svg';
import assetsImg from '../static_files/Transactions.svg';
import c2cImg from '../static_files/C2C Network.svg';
import inviteImg from '../static_files/Invite-friends.svg';
import accountImg from '../static_files/Account_leftPanel.svg'
import accountBlackImg from '../static_files/Account_leftPanel_black.svg'
import chatImg from '../static_files/KRA.svg'
import moreImg from '../static_files/more-horizontal.svg'

import renameImg from '../static_files/edit-03.png'
import deleteImg from '../static_files/delete-2.png'
import expandImg from "../static_files/left panel expand.svg";
import shrinkAccountImg from '../static_files/Account icon.svg'
import TooltipRight from "../Tooltip/TooltipRight";
import goldShrinkAccountImg from '../static_files/badge gold.svg';
import sapphireShrinkAccountImg from '../static_files/badge sapphire.svg';
import silverShrinkAccountImg from '../static_files/badgesliver.svg';

const BACKEND_URL = 'https://kira-ai-256611876551.europe-west1.run.app/'
// const BACKEND_URL = 'https://kira-ai-256611876551.us-central1.run.app'
// const BACKEND_URL = 'http://127.0.0.1:8080';

const LeftPanel = ({
                       walletAddress,
                       onLoadingChange,
                       isTransactionPage = false,    //对transaction history page 做特殊style处理
                       isAutoShrink = false,           //判断是不是缩小版本
                       onPanelStateChange = (state) => {
                       },  // 新增的回调 prop 传出去
                   }) => {
    const isLargeScreen = useIsMobile(1265);

    const [currentPath, setCurrentPath] = useState('');
    const navigate = useNavigate();
    const {
        conversations,
        setConversations,
        currentConversationId,
        setCurrentConversationId
    } = useContext(SwapMainAppContext);
    const [shrinkLeftPanel, setShrinkLeftPanel] = useState(() => {
        const savedState = localStorage.getItem('shrinkLeftPanel');
        return savedState !== null ? JSON.parse(savedState) : false;
    });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [chatToDelete, setChatToDelete] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const moreBtnRefs = useRef({});
    const [editingChatId, setEditingChatId] = useState(null);
    const [editingTitle, setEditingTitle] = useState('');
    const [userClass, setUserClass] = useState(
        localStorage.getItem('userClass') || 'General Member'
    );
    useEffect(() => {
        setCurrentPath(window.location.pathname);
    }, []);
    const handleToggleShrink = () => {
        setShrinkLeftPanel(prevState => {
            const newState = !prevState;
            // 保存到localStorage
            localStorage.setItem('shrinkLeftPanel', JSON.stringify(newState));
            onPanelStateChange(newState);

            return newState;
        });
    };
    // 如果传入屏幕过小
    useEffect(() => {
        if (isAutoShrink || isLargeScreen) {
            setShrinkLeftPanel(true)
        }
    }, [isAutoShrink, isLargeScreen]);

    useEffect(() => {
        document.documentElement.style.setProperty(
            '--panel-width',
            shrinkLeftPanel ? "60px" : "188px"
        );
    }, [shrinkLeftPanel]);

    // Add effect to fetch conversation titles on load
    useEffect(() => {
        const fetchConversationTitles = async () => {
            if (!walletAddress) {
                setIsLoading(false);
                if (onLoadingChange) onLoadingChange(false);
                return;
            }
            try {
                setIsLoading(true);
                if (onLoadingChange) onLoadingChange(true);

                const response = await axios.get(`${BACKEND_URL}/api/conversations/titles`, {
                    params: {wallet_address: walletAddress}
                });
                const titledConversations = response.data.conversations.map(conv => ({
                    id: conv.id,
                    title: conv.title,
                    timestamp: conv.timestamp,
                    // Keep lastMessage as null initially - it will be populated when conversation is selected
                    lastMessage: null
                }));

                setConversations(titledConversations);
            } catch (error) {
                console.error('Error fetching conversation titles:', error);
            } finally {
                setIsLoading(false);
                if (onLoadingChange) onLoadingChange(false);
            }
        };

        fetchConversationTitles();
    }, [walletAddress]);

    useEffect(() => {
        const handleClick = () => setOpenDropdownId(null);
        if (openDropdownId !== null) {
            document.addEventListener('click', handleClick);
        }
        return () => document.removeEventListener('click', handleClick);
    }, [openDropdownId]);

    const handleMyAssetsClick = () => {
        const token = localStorage.getItem('gatewayToken');
        if (token) {
            navigate(`/swap?token=${token}`);
        } else {
            navigate('/');
        }
    };

    const handleSelectConversation = (id) => {
        setCurrentConversationId(id);
        // Pass the selected conversation's messages to KiraAI
        const selectedConv = conversations.find(conv => conv.id === id);
        if (selectedConv) {
            navigate('/kira-ai', {state: {messages: selectedConv.messages}});
        }
    };

    const handleDeleteClick = (e, chatId) => {
        e.stopPropagation(); // Prevent chat selection
        setChatToDelete(chatId);
        setShowDeleteModal(true);
    };

    function getContainerClass(userClass, styles, currentPath) {
        if (userClass === 'Sapphire VIP') {
            return currentPath === '/account' ? styles.selectedSapphireContainer : styles.sapphireContainer;
        } else if (userClass === 'Silver VIP') {
            return currentPath === '/account' ? styles.selectedSilverContainer : styles.silverContainer;
        } else if (userClass === 'Gold VIP') {
            return currentPath === '/account' ? styles.selectedGoldContainer : styles.goldContainer;
        } else {
            return currentPath === '/account' ? styles.selectedAccountContainer : styles.accountContainer;
        }
    }

    function getIconImage(userClass, currentPath, iconaccountImgImg, accountBlackImg) {
        if (currentPath === '/account' &&
            (userClass === 'Silver VIP' || userClass === 'Gold VIP')) {
            return accountBlackImg; // 使用黑色图标
        } else {
            return accountImg;
        }
    }

    function getShrinkIconImage(userClass) {
        if (userClass === 'Sapphire VIP') {
            return sapphireShrinkAccountImg;
        } else if (userClass === 'Silver VIP') {
            return silverShrinkAccountImg;
        } else if (userClass === 'Gold VIP') {
            return goldShrinkAccountImg;
        } else {
            return shrinkAccountImg;
        }
    }

    const containerClass = getContainerClass(userClass, styles, currentPath)
    const accountIcon = getIconImage(userClass, currentPath, accountImg, accountBlackImg);
    const shrinkAccountIcon = getShrinkIconImage(userClass)

    useEffect(() => {
        if (walletAddress) {

            // TODO Maybe bug here
            setTimeout(() => {
                setUserClass(localStorage.getItem('userClass') || 'General Member');
                //TODO change it back
                // setUserClass('Sapphire VIP')
            }, 500);
        }
    }, [walletAddress]);
    const handleDeleteConfirm = async (chatId) => {
        try {
            const updatedConversations = conversations.filter(conv => conv.id !== chatId);
            setConversations(updatedConversations);

            if (currentConversationId === chatId) {
                setCurrentConversationId(null);
                localStorage.removeItem('kiraCurrentConversationId');
            }

            // Update localStorage
            localStorage.setItem("kiraConversations", JSON.stringify(updatedConversations));

            // Only call backend if we have a wallet address
            if (walletAddress) {
                console.log('Deleting chat:', chatId, 'with wallet address:', walletAddress);
                await axios.delete(`${BACKEND_URL}/api/conversation/${chatId}`, {
                    params: {wallet_address: walletAddress}
                });
                console.log('Successfully deleted chat:', chatId);
            }
        } catch (error) {
            console.error('Error deleting chat:', error);
        } finally {
            setShowDeleteModal(false);
            setChatToDelete(null);
        }
    };

    return (
        <div
            className={
                shrinkLeftPanel
                    ? `${styles.shrinkLeftPanel} ${isTransactionPage ? styles.leftPanel2 : styles.leftPanel}`
                    : (isTransactionPage ? styles.leftPanel2 : styles.leftPanel)
            }
        >
            <div
                style={{backgroundColor: '#000000', width: '100%'}}
            >
                {shrinkLeftPanel ?
                    <div style={{backgroundColor: '#000000', display: 'flex', alignItems: 'center', height: '41px'}}>
                        <button className={styles.iconButton} onClick={handleToggleShrink}
                                style={{marginLeft: '14px'}}>
                            <img
                                src={expandImg}
                                alt="expandImg"
                            />
                        </button>
                    </div>
                    : <div style={{backgroundColor: '#000000', display: 'flex', alignItems: 'center', height: '41px'}}>
                        <img
                            style={{backgroundColor: '#000000', cursor: 'pointer', marginLeft: '1px'}}
                            className={styles.vectorIcon}
                            alt="KiraAI"
                            src={logoImg}
                            onClick={() => window.open('https://kira.trading', '_blank')}
                        />
                        <button className={styles.iconButton} onClick={handleToggleShrink}>
                            <img
                                src={expandImg}
                                alt="expandImg"
                            />
                        </button>
                    </div>
                }
            </div>

            {/* Menu */}
            <div className={styles.leftMenu} style={{width: shrinkLeftPanel ? '60px' : '188px'}}>
                <ul className={styles.leftOptionUl}
                    style={{backgroundColor: '#000000', width: shrinkLeftPanel ? '60px' : '188px'}}>
                    {/* My Assets */}
                    <li
                        className={
                            currentPath === '/'
                                ? `${styles.leftOption} ${styles.activeGrey}`
                                : styles.leftOption
                        }
                        style={{paddingLeft: shrinkLeftPanel ? '22px' : '15px'}}
                        onClick={handleMyAssetsClick}
                    >
                        {shrinkLeftPanel ?
                            <TooltipRight text={<>My Assets</>} backgroundColor={"#32363D"} borderRadius={"6px"}>
                                <img
                                    style={{marginRight: '16.53px'}}
                                    src={transImg}
                                    alt="My Assets icon"
                                />
                            </TooltipRight> :
                            <img
                                style={{marginRight: '16.53px'}}
                                src={transImg}
                                alt="My Assets icon"
                            />}

                        {!shrinkLeftPanel && "My Assets"}

                    </li>

                    {/* Transactions */}
                    <li
                        className={
                            currentPath === '/transaction'
                                ? `${styles.leftOption} ${styles.activeGrey}`
                                : styles.leftOption
                        }
                        style={{paddingLeft: shrinkLeftPanel ? '22px' : '15px'}}
                        onClick={() => navigate('/transaction')}
                    >
                        {shrinkLeftPanel ?
                            <TooltipRight text={<>Transactions</>} backgroundColor={"#32363D"} borderRadius={"6px"}>
                                <img
                                    style={{marginRight: '16.53px', marginLeft: "-1px"}}
                                    src={assetsImg}
                                    alt="Transactions icon"
                                />
                            </TooltipRight> :
                            <img
                                style={{marginRight: '16.53px', marginLeft: "-1px"}}
                                src={assetsImg}
                                alt="Transactions icon"
                            />}
                        {!shrinkLeftPanel && "Transactions"}
                    </li>

                    <li
                        className={
                            currentPath === '/c2c'
                                ? `${styles.leftOption} ${styles.activeGrey}`
                                : styles.leftOption
                        }
                        style={{paddingLeft: shrinkLeftPanel ? '22px' : '15px'}}
                        onClick={() => navigate('/c2c')}>
                        {shrinkLeftPanel ?
                            <TooltipRight text={<>C2C Network</>} backgroundColor={"#32363D"} borderRadius={"6px"}>
                                <img
                                    style={{marginRight: '13.5px', marginLeft: "-1px"}}
                                    src={c2cImg}
                                    alt="C2C icon"
                                />
                            </TooltipRight> : <img
                                style={{marginRight: '13.5px', marginLeft: "-1px"}}
                                src={c2cImg}
                                alt="C2C icon"
                            />}
                        {!shrinkLeftPanel && "C2C Network"}
                    </li>


                    {/* Invite Friends */}
                    <li className={
                        currentPath === '/invite'
                            ? `${styles.leftOption} ${styles.activeGrey}`
                            : styles.leftOption
                    }
                        style={{paddingLeft: shrinkLeftPanel ? '22px' : '15px'}}
                        onClick={() => navigate('/invite')}>
                        {shrinkLeftPanel ?
                            <TooltipRight text={<>Invite Friends</>} backgroundColor={"#32363D"} borderRadius={"6px"}>
                                <img
                                    style={{marginRight: '13.5px', marginLeft: "-1px"}}
                                    src={inviteImg}
                                    alt="Invite icon"
                                />
                            </TooltipRight> : <img
                                style={{marginRight: '13.5px', marginLeft: "-1px"}}
                                src={inviteImg}
                                alt="Invite icon"
                            />}
                        {!shrinkLeftPanel && "Invite Friends"}
                    </li>
                    {/* Kira AI */}
                    <li
                        className={
                            currentPath === '/kira-ai'
                                ? `${styles.leftOption} ${styles.activeGrey}`
                                : styles.leftOption
                        }
                        style={{paddingLeft: shrinkLeftPanel ? '14px' : '15px'}}
                        onClick={() => navigate('/kira-ai')}
                    >
                        {shrinkLeftPanel ?
                            <TooltipRight text={<>KIRA Chat</>} backgroundColor={"#32363D"} borderRadius={"6px"}>
                                <img
                                    style={{marginRight: '10px', width: '32px', height: '32px'}}
                                    src={chatImg}
                                    alt="Kira AI icon"
                                />
                            </TooltipRight> : <img
                                style={{marginRight: '10px', width: '32px', height: '32px'}}
                                src={chatImg}
                                alt="Kira AI icon"
                            />}
                        {!shrinkLeftPanel && " KIRA Chat"}
                    </li>
                    {!shrinkLeftPanel && (
                        <div
                            style={{
                                width: '163px',
                                height: '1px',
                                backgroundColor: '#343434',
                                marginInline: '13px',
                                marginTop: '20px'
                            }}
                        />
                    )}
                </ul>
            </div>

            {/* Recent Chats Section - Only show on Kira AI tab */}
            {/*{currentPath === '/kira-ai' && (*/}
            {!shrinkLeftPanel && (<div className={styles.recentChats}>
                {conversations.length !== 0 && (<h3 className={styles.recentChatsTitle}>Recent chats</h3>)}

                <div className={styles.chatScrollArea}>
                    {isLoading ? (
                        <div className={styles.loadingContainer}>
                            <div className={styles.loadingSpinner}></div>
                        </div>
                    ) : conversations.length === 0 ? (
                        <div className={styles.chatList}>
                        </div>

                    ) : (
                        <ul className={styles.chatList}>
                            {conversations.map((conv) => {
                                if (!moreBtnRefs.current[conv.id]) {
                                    moreBtnRefs.current[conv.id] = React.createRef();
                                }
                                const isEditing = editingChatId === conv.id;
                                return (
                                    <li
                                        key={conv.id}
                                        className={`${styles.chatItem} ${conv.id === currentConversationId ? styles.activeChat : ''}`}
                                        onClick={() => handleSelectConversation(conv.id)}
                                        style={{position: 'relative'}}
                                    >
                                        <div style={{height: "36px", display: 'flex', alignItems: 'center'}}>
                                            {isEditing ? (
                                                <input
                                                    className={styles.editTitleInput}
                                                    value={editingTitle}
                                                    autoFocus
                                                    onChange={e => setEditingTitle(e.target.value)}
                                                    onBlur={async () => {
                                                        if (editingTitle.trim() && editingTitle !== conv.title) {
                                                            setConversations(prev => prev.map(c => c.id === conv.id ? {
                                                                ...c,
                                                                title: editingTitle
                                                            } : c));
                                                            setEditingChatId(null);
                                                            try {
                                                                await axios.put(`${BACKEND_URL}/api/conversation/${conv.id}/title`, {
                                                                    wallet_address: walletAddress,
                                                                    title: editingTitle
                                                                });
                                                            } catch (err) {
                                                                console.error('Failed to update title:', err);
                                                                // Optionally: show error to user or revert title
                                                            }
                                                        } else {
                                                            setEditingChatId(null);
                                                        }
                                                    }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            e.target.blur();
                                                        }
                                                    }}
                                                    style={{width: '80%', fontSize: '15px'}}
                                                />
                                            ) : (
                                                <span className={styles.chatItemContent}>
                                                    {conv.title
                                                        ? (conv.title.length > 25 ? conv.title.slice(0, 25) + '...' : conv.title)
                                                        : conv.lastMessage
                                                            ? (conv.lastMessage.length > 25 ? conv.lastMessage.slice(0, 25) + '...' : conv.lastMessage)
                                                            : 'New Conversation'}
                                                </span>
                                            )}
                                        </div>
                                        <img
                                            ref={moreBtnRefs.current[conv.id]}
                                            className={`${styles.moreOptions} ${conv.id === currentConversationId ? styles.activeMoreOptions : ''}`}
                                            onClick={e => {
                                                e.stopPropagation();
                                                setOpenDropdownId(openDropdownId === conv.id ? null : conv.id);
                                            }}
                                            src={moreImg}
                                        />
                                        {openDropdownId === conv.id && (
                                            <PortalDropdown
                                                anchorRef={moreBtnRefs.current[conv.id]}
                                                onClose={() => setOpenDropdownId(null)}
                                            >
                                                <div className={styles.dropdownMenu}>
                                                    <div
                                                        className={styles.dropdownItem}
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            setOpenDropdownId(null);
                                                            setEditingChatId(conv.id);
                                                            setEditingTitle(conv.title || '');
                                                        }}
                                                    >
                                                        <img className={styles.renameIcon} src={renameImg}
                                                             alt="Rename"/>
                                                        Rename
                                                    </div>
                                                    <div
                                                        className={styles.dropdownItem}
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            setOpenDropdownId(null);
                                                            setChatToDelete(conv.id);
                                                            setShowDeleteModal(true);
                                                        }}
                                                    >
                                                        <img className={styles.deleteIcon} src={deleteImg}
                                                             alt="Delete"/>
                                                        Delete
                                                    </div>
                                                </div>
                                            </PortalDropdown>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            </div>)}

            {/* Account */}
            <div className={styles.leftMenu} style={{width: shrinkLeftPanel ? '59.5px' : '188px'}}>
                <div className={styles.accountOuterContainer}
                     style={{
                         paddingLeft: shrinkLeftPanel ? '11px' : '15px',
                         width: shrinkLeftPanel ? '59.5px' : '187px',
                         paddingTop: shrinkLeftPanel ? '25px' : '0'
                     }}>
                    {shrinkLeftPanel ?

                        // <TooltipRight  text={<>Account</>} backgroundColor={"#32363D"} borderRadius={"6px"}>
                        <img
                            style={{
                                backgroundColor: 'transparent',
                                height: "38px",
                                width: "38px",
                                cursor: 'pointer'

                            }}
                            onClick={() => navigate('/account')}
                            src={shrinkAccountIcon}
                            alt="account icon"
                        />
                        // </TooltipRight>
                        : <div
                            className={
                                `${styles.accountContainer} ` +
                                `${containerClass} ` +
                                `${currentPath === '/account' ? styles.activeGrey : ''}`
                            }
                            onClick={() => navigate('/account')}
                        >
                            <img
                                style={{
                                    backgroundColor: 'transparent',
                                    marginRight: '8.67px',
                                    marginLeft: "21px",
                                    height: "14.67px",
                                    width: "14.67px"
                                }}
                                src={accountIcon}
                                alt="account icon"
                            />
                            Account
                        </div>}
                </div>
            </div>

            {showDeleteModal && (
                <DeleteChatModal
                    isOpen={showDeleteModal}
                    onClose={() => {
                        setShowDeleteModal(false);
                        setChatToDelete(null);
                    }}
                    onDelete={() => handleDeleteConfirm(chatToDelete)}
                    chatId={chatToDelete}
                />
            )}
        </div>
    );
};

LeftPanel.propTypes = {
    walletAddress: PropTypes.string, // Optional prop
    onLoadingChange: PropTypes.func // Optional prop
};

export default LeftPanel;